import React from "react";
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import {
    Row, Col,
} from "reactstrap";

export default class ContentHeadDashboard extends React.Component {
    constructor(props) {
        super(props);
        console.log(this.props.head_badge_contents)
        this.state = {
            contents: this.props.head_badge_contents? this.props.head_badge_contents : {},
        }
    }

    render() {
        return (
            <>
                <div className="border" style={{width: '100%', padding: '5px'}}>
                    <Row>
                        <Col>{GsuiteAuth.get('name')}
                        {
                            Object.keys(this.props.head_badge_contents).map((key, index) => ( 
                                <>  {key} {this.props.head_badge_contents[key]}件</>
                            ))
                        }
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}
